import SystemHealthWidget from "@/components/SystemHealthWidget";

/**
 * Super Admin-only System Health center.
 *
 * Hosts the same live-API + Email log + System Events surface that
 * previously lived on the Dashboard. Keeping it on its own route means
 * the executive dashboard stays lean (Capacity / Active Plants / Open
 * Tickets only) while operators still have one click to every upstream
 * diagnostic.
 *
 * Route is gate-kept to `super_admin` at `App.js`; the sidebar link is
 * gated by the same role.
 */
export default function SystemHealth() {
    return (
        <div className="space-y-6" data-testid="system-health-page">
            <div>
                <div className="text-[10px] font-semibold uppercase tracking-[0.18em] text-zinc-500">Super Admin</div>
                <h1 className="text-4xl sm:text-5xl font-semibold tracking-tight text-zinc-900 mt-1">System Health</h1>
                <p className="text-sm text-[#6B7280] mt-1">
                    Live API status for every upstream, the last 20 outbound emails with retry controls, and a rolling audit of system events.
                </p>
            </div>
            <SystemHealthWidget />
        </div>
    );
}
